<template>
  <div :class="{ loader: true, fadeout: !isLoading }">
    <div id="splashtext">Believe in yourself. <br>We do.</div>
  </div>
</template>

<script>
export default {
  name: "launch-screen",
  props: ["isLoading"]
};
</script>

<style>
.loader {
  background-color: #1b589f;
  bottom: 0;
  color: white;
  display: block;
  font-size: 32px;
  left: 0;
  overflow: hidden;
  position: fixed;
  right: 0;
  text-align: right;
  top: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  justify-content: center;
  z-index: 999;
}
#splashtext {
  font-weight: 600;
  text-align: center;
  font-size: 36px;
  line-height: 46px;
}

.fadeout {
  animation: fadeout 1s forwards;
  animation-delay: 1s;
}

@keyframes fadeout {
  to {
    opacity: 0;
    visibility: hidden;
  }
}
</style>